import { dashboardMockAdapter } from "./dashboardMockAdapter";

const BASE_URL = process.env.REACT_APP_FLASK_API_ENDPOINT || "https://camplbellsoupsv1devui.azurewebsites.net/v1";
const USE_MOCK = process.env.REACT_APP_DASHBOARD_USE_MOCK === "true";

const dashboardRequest = async (endpoint, method = "POST", body = null) => {
  const accessToken = localStorage.getItem("accessToken");
  const headers = {
    "Content-Type": "application/json",
  };

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const options = {
    method,
    headers,
    mode: "cors",
    credentials: "omit",
  };

  if (body && method !== "GET") {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, options);
    if (!response.ok) {
      const message = await response.text();
      throw new Error(message || `Request failed with status ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    return {
      error: true,
      message: error.message || "Request failed",
    };
  }
};

const withFallback = async (endpoint, payload, fallbackFn) => {
  if (USE_MOCK) {
    return fallbackFn();
  }

  const apiResponse = await dashboardRequest(endpoint, "POST", payload);

  // Allow backend to return either { data } or a plain payload.
  if (apiResponse?.error) {
    throw new Error(apiResponse?.message || "Dashboard API request failed");
  }

  return apiResponse?.data || apiResponse;
};

/**
 * JSDoc typedefs keep response contracts explicit in this JS codebase.
 * @typedef {{label: string, value: string}} FilterOption
 * @typedef {{kpis: Array<Object>, trends: Array<Object>, sentimentDistribution: Array<Object>}} ExecutiveOverviewResponse
 */

export const getDashboardFilterOptions = async () =>
  withFallback("/dashboard/filter-options", null, dashboardMockAdapter.getFilterOptions);

export const getExecutiveOverview = async (filters) =>
  withFallback("/dashboard/executive-overview", filters, dashboardMockAdapter.getExecutiveOverview);

export const getSocialPerformance = async (filters) =>
  withFallback("/dashboard/social-performance", filters, dashboardMockAdapter.getSocialPerformance);

export const getPlatformPerformance = async (filters) =>
  withFallback("/dashboard/platform-performance", filters, dashboardMockAdapter.getPlatformPerformance);

export const getSentimentAnalysis = async (filters) =>
  withFallback("/dashboard/sentiment-analysis", filters, dashboardMockAdapter.getSentimentAnalysis);

export const getFlavourInsights = async (filters) =>
  withFallback("/dashboard/flavour-insights", filters, dashboardMockAdapter.getFlavourInsights);

export const getTopicInsights = async (filters) =>
  withFallback("/dashboard/topic-insights", filters, dashboardMockAdapter.getTopicInsights);

export const getReviewInsights = async (filters) =>
  withFallback("/dashboard/review-insights", filters, dashboardMockAdapter.getReviewInsights);

export const getAlerts = async (filters) =>
  withFallback("/dashboard/alerts", filters, dashboardMockAdapter.getAlerts);

export const getMarketContext = async (filters) =>
  withFallback("/dashboard/market-context", filters, dashboardMockAdapter.getMarketContext);

export const getDimensionExplorerData = async (payload) =>
  withFallback("/dashboard/dimension-explorer", payload, dashboardMockAdapter.getDimensionExplorer);

export const getDetailedPerformance = async (filters) =>
  withFallback("/dashboard/detailed-performance", filters, dashboardMockAdapter.getDetailedPerformance);
